/** URLs derived from where the client is served (the game server serves the client too). */

/** Same-origin WebSocket endpoint: wss on https pages, ws on http (local development). */
export function webSocketUrl(location: Pick<Location, 'protocol' | 'host'>): string {
  const scheme = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${location.host}/ws`;
}

/** Address a friend should open to join (used for the invite QR code and link). */
export function inviteUrl(location: Pick<Location, 'origin'>): string {
  return `${location.origin}/`;
}
